// extracted by mini-css-extract-plugin
export default {"animated":"AnimatedText_animated__d0PL4","rainbow":"AnimatedText_rainbow__CXMBY"};